import { format } from 'date-fns';
import { observer } from 'mobx-react-lite';
import React, { Fragment, useContext } from 'react';
import { Item, Label } from 'semantic-ui-react';
import { RootStoreContext } from '../../../app/stores/rootStore';
import ActivityListItem from './ActivityListItem';

const ActivityList: React.FC = () => {
    const rootStore = useContext(RootStoreContext);
    const { activitiesByDate } = rootStore.activityStore;
    return (
        <Fragment>
            {activitiesByDate.map(([group, activities]) => {
                return (
                    <Fragment key={group}>
                        <Label size='large' color='blue'>
                            {format(group, 'eeee do MMM')}
                        </Label>
                        <Item.Group divided>
                            {activities.map(activity =>
                            (
                                <ActivityListItem key={activity.id} activity={activity} />
                            ))}
                        </Item.Group>
                    </Fragment>
                )
            })}
        </Fragment>
    )
}

export default observer(ActivityList)
